import { gsap } from "gsap";
import { ScrambleTextPlugin } from "gsap/ScrambleTextPlugin";

// Register the ScrambleTextPlugin
gsap.registerPlugin(ScrambleTextPlugin);

// Make the text visible first, then start the scramble effect
gsap.set(".h1-animate", { visibility: "visible" });

// Animate each element individually to preserve their original text
document.querySelectorAll(".h1-animate").forEach((element) => {
  const originalText = element.textContent;

  gsap.to(element, {
    duration: 3, // Adjust the duration as needed
    scrambleText: {
      text: originalText, // Use the original text content
      chars: "01", // Random characters '0' and '1' during scrambling
      speed: 3, // Scrambling speed
      revealDelay: 0.5, // Delay before revealing the final text
      tweenLength: true, // Make it look like typing
    },
  });
});
